const initTitle = () => {

    window.addEventListener("DOMContentLoaded", function () {
        var optionTitle = $('.profile-menu-item-active').children('p').html();
        $('.profile-menu-dropdown-toggler').html(optionTitle);
    });
};

export {
    initTitle
};
